import {
  provideSoftAppsModule,
  withSoftAppsModuleNavItem,
  withSoftAppsModuleRoutes,
  withSoftAppsModuleTranslation,
} from '@softapps/core';
import { getModuleGroupByName } from '@softline/application';
import { default as de } from '../i18n/de.json';
import { designSystemRoutes } from './design-system.routes';

export const provideDesignSystemCatalogModule = () => [
  provideSoftAppsModule(
    {
      name: 'DesignSystemCatalog',
      title: '#DESIGN_SYSTEM_CATALOG.TITLE',
      icon: 'fa-regular fa-swatchbook',
      route: '/design-system',
      group: getModuleGroupByName('Technik'),
      permission: 'SOFTAPPS.DESIGN_SYSTEM_CATALOG',
      badge: 'docs',
    },
    withSoftAppsModuleRoutes({ app: designSystemRoutes }),
    withSoftAppsModuleTranslation({ de }),
    withSoftAppsModuleNavItem([
      {
        name: 'design-system-overview',
        title: '#DESIGN_SYSTEM_CATALOG.TITLE',
        icon: 'fa-regular fa-swatchbook',
        routerLink: ['/design-system/overview'],
        entry: true,
      },
    ])
  ),
];
